import { useEffect, type DependencyList, type ReactNode } from 'react';
import { useRightSlotStore } from '../store/rightSlotStore';

// 현재 화면이 PhotoOrganizerLayout의 우측 컨테이너에 보여줄 콘텐츠를 등록한다.
// 화면 전환/언마운트 시 자동으로 비운다.
export function useRightSlot(node: ReactNode, deps: DependencyList) {
  const setContent = useRightSlotStore(s => s.setContent);

  useEffect(() => {
    setContent(node);
    return () => setContent(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
